import { render, staticRenderFns } from "./ProgressPaymentPix.vue?vue&type=template&id=90b9a5a8"
import script from "./ProgressPaymentPix.vue?vue&type=script&lang=js"
export * from "./ProgressPaymentPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports